<template>
  <main class="u-margin-top-8x">
    <BaseStateIndicator v-if="hasError" state="error" />
    <BaseSpinner v-else />
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { BaseSpinner, BaseStateIndicator } from '@te/cdev-design-system';

import { getSamlLogoutPayload } from '@/common/services/SingleSignOn';
import { samlSetup } from '@/common/helpers/single-sign-on';
import AuthService from '@/common/services/Auth';
import { setupStyling } from '@te/cdev-utils';

export default defineComponent({
  components: {
    BaseSpinner,
    BaseStateIndicator
  },
  metaInfo() {
    return {
      title: this.$t('common.redirecting')
    };
  },
  data() {
    return {
      hasError: false
    };
  },
  async created() {
    try {
      await samlSetup(getSamlLogoutPayload, 'logout_redirect_url');
      AuthService.deauthenticate();
      setupStyling();
    } catch (error) {
      console.error(error);
      this.hasError = true;
    }
  }
});
</script>
